// Lightweight i18n — UI strings only (per user choice 4a)
// Add a new language by appending a block; missing keys fall back to English.

export const LANGUAGES = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'nl', label: 'Nederlands', flag: '🇳🇱' },
  { code: 'de', label: 'Deutsch', flag: '🇩🇪' },
  { code: 'fr', label: 'Français', flag: '🇫🇷' },
];

const translations = {
  en: {
    // Header
    'nav.home': 'Home',
    'nav.shop': 'Shop',
    'nav.about': 'About Us',
    'nav.contact': 'Contact',
    'nav.admin': 'Admin',
    'nav.search_placeholder': 'Search flavors, vapes…',
    // Hero
    'hero.eyebrow': 'Premium Disposable Vapes',
    'hero.tagline1': 'We Supply',
    'hero.tagline2': 'Smoke.',
    'hero.subtitle': 'Authentic RandM Fumot Tornado 15K & 20K disposable vapes — fresh inventory, unbeatable flavors, lightning-fast shipping.',
    'hero.cta_primary': 'Shop the Drop',
    'hero.cta_secondary': 'View all 60 15K flavors',
    'hero.f_puffs': '15,000–20,000 puffs',
    'hero.f_mesh': 'Mesh coil tech',
    'hero.f_usb': 'USB-C rechargeable',
    'hero.f_authentic': 'Authentic & sealed',
    // Crypto banner
    'banner.eyebrow': 'Crypto Exclusive',
    'banner.title_a': 'Pay with crypto and get',
    'banner.title_b': '15% off',
    'banner.title_c': 'your entire order.',
    'banner.subtitle': 'BTC · ETH · LTC · USDT — discount auto-applied at checkout.',
    'banner.cta': 'Shop now',
    // Shop
    'shop.title': 'Shop',
    'shop.search_placeholder': 'Search products…',
    'shop.no_results': 'No products match your search.',
    'shop.add_to_cart': 'Add to cart',
    'shop.filter_all': 'All categories',
    // Cart
    'cart.title': 'Your cart',
    'cart.empty': 'Your cart is empty',
    'cart.continue': 'Continue shopping',
    'cart.checkout': 'Checkout',
    'cart.qty': 'Qty',
    'cart.remove': 'Remove',
    'cart.subtotal': 'Subtotal',
    'cart.shipping_calc': 'Shipping calculated at checkout',
    // Checkout
    'checkout.title': 'Checkout',
    'checkout.contact_shipping': 'Contact & Shipping',
    'checkout.email': 'Email',
    'checkout.phone': 'Phone',
    'checkout.phone_required': 'Phone number is required',
    'checkout.phone_help': 'Required — courier may call you for delivery.',
    'checkout.first_name': 'First name',
    'checkout.last_name': 'Last name',
    'checkout.address': 'Address',
    'checkout.city': 'City',
    'checkout.postal': 'Postal code',
    'checkout.country': 'Country',
    'checkout.shipping_to': 'Shipping to',
    'checkout.free_unlocked': 'Free shipping unlocked!',
    'checkout.payment_method': 'Payment Method',
    'checkout.payment_info': 'Pay with crypto directly for a 15% discount, or choose iDEAL / card / Bancontact / PayPal — those redirect to a voucher provider (Bitrefill / Azteco / Bitnovo) where you buy a crypto voucher and paste the code back here.',
    'checkout.your_order': 'Your order',
    'checkout.no_items': 'No items —',
    'checkout.add_some': 'add some',
    'checkout.promo_code': 'Promo code',
    'checkout.apply': 'Apply',
    'checkout.remove_coupon': 'Remove',
    'checkout.subtotal': 'Subtotal',
    'checkout.discount': 'Discount',
    'checkout.shipping': 'Shipping',
    'checkout.free': 'Free',
    'checkout.total': 'Total',
    'checkout.place_order': 'Place order',
    'checkout.processing': 'Processing…',
    'checkout.empty_cart': 'Your cart is empty',
    // Voucher page
    'voucher.eyebrow': 'Order Placed',
    'voucher.thanks': 'Thanks',
    'voucher.intro': 'Follow the steps below to complete payment via crypto voucher.',
    'voucher.status': 'Awaiting Voucher',
    'voucher.how_to_pay': 'How to pay',
    'voucher.step1_a': 'Visit one of the voucher providers below and purchase a',
    'voucher.step1_b': 'Bitcoin (or USDT) voucher',
    'voucher.step1_c': 'for the exact amount of',
    'voucher.step2': 'Pay with your preferred fiat method on the voucher provider (iDEAL, card, PayPal, Bancontact, cash, etc.).',
    'voucher.step3_a': 'Email your voucher redeem code to',
    'voucher.step3_b': 'together with your order number',
    'voucher.step4': 'Once we redeem the voucher we ship your order — usually within 24 hours.',
    'voucher.providers_title': 'Recommended voucher providers',
    'voucher.open': 'Open',
    'voucher.no_providers': 'No voucher providers configured. Please contact support.',
    'voucher.send_code': 'Send your voucher code',
    'voucher.send_code_help': 'Once you have your voucher code, click below to email it to us with your order number pre-filled.',
    'voucher.email_btn': 'Email voucher code',
    'voucher.summary': 'Order summary',
    'voucher.total_to_pay': 'Total to pay',
    // Footer / common
    'common.shipping': 'Shipping',
    'common.support': 'Support',
    'common.privacy': 'Privacy',
    'common.terms': 'Terms',
    'common.legal': 'Legal',
    'common.copyright': 'All rights reserved.',
    // Language switcher
    'lang.switch': 'Language',
    // Age gate popup
    'agegate.eyebrow': 'Adults only',
    'agegate.title': 'You must be {age}+ to enter',
    'agegate.body': 'This store sells nicotine products. Please confirm you are at least {age} years old to continue.',
    'agegate.yes': "I'm {age} or older — enter",
    'agegate.no': 'I am under age — leave',
    'agegate.footer': 'By entering, you confirm you meet the legal age in your country.',
    // Product detail
    'product.add_to_cart': 'Add to cart',
    'product.buy_now': 'Buy now',
    'product.description': 'Description',
    'product.reviews': 'Reviews',
    'product.related': 'You might also like',
    'product.in_stock': 'In stock',
    'product.out_of_stock': 'Out of stock',
    'product.fast_shipping': 'Fast discreet shipping',
    'product.authentic': 'Authentic & sealed',
    'product.pay_options': 'iDEAL / Card / Crypto',
    // Account (customer)
    'account.login_title': 'Sign In',
    'account.login_subtitle': 'Log in to your account to complete your order.',
    'account.register_title': 'Create Account',
    'account.register_subtitle': 'You must be 18+ and provide a phone so we can arrange your order.',
    'account.password': 'Password',
    'account.min_8': 'min. 8 characters',
    'account.sign_in': 'Sign in',
    'account.no_account': "Don't have an account?",
    'account.have_account': 'Already have an account?',
    'account.create_account': 'Create account',
    'account.full_name': 'Full name',
    'account.birthdate': 'Date of birth',
    'account.age_blocked': 'You must be at least 18 years old.',
    'account.birthdate_required': 'Date of birth is required.',
    'account.password_short': 'Password must be at least 8 characters.',
    'account.welcome': 'Welcome!',
    'account.logout': 'Sign out',
    'account.my_account': 'My account',
    'account.required_notice': 'You need an account to place an order — sign up in 30 seconds.',
    // Thanks page
    'thanks.eyebrow': 'Thank you for your order',
    'thanks.status': 'Awaiting Contact',
    'thanks.intro_a': 'Hi ',
    'thanks.intro_b': ', we received your order! A representative will contact you shortly to arrange payment and shipping.',
    'thanks.next_steps': 'What happens next',
    'thanks.step_call': 'We call/message you within 24 hours on the phone number you provided.',
    'thanks.step_confirm': 'We confirm details and arrange the easiest payment method for you.',
    'thanks.step_ship': 'We ship your order the same or next business day after confirmation.',
    'thanks.contact_us': 'Need to reach us first?',
    'thanks.reference': 'Please quote order',
    'thanks.not_found': 'Order not found',
    'thanks.not_found_hint': 'Please double-check the order number or contact support.',
  },
  nl: {
    'nav.home': 'Home',
    'nav.shop': 'Winkel',
    'nav.about': 'Over ons',
    'nav.contact': 'Contact',
    'nav.admin': 'Admin',
    'nav.search_placeholder': 'Zoek smaken, vapes…',
    'hero.eyebrow': 'Premium Disposable Vapes',
    'hero.tagline1': 'We Supply',
    'hero.tagline2': 'Smoke.',
    'hero.subtitle': 'Authentieke RandM Fumot Tornado 15K & 20K disposable vapes — verse voorraad, ongeëvenaarde smaken, bliksemsnelle verzending.',
    'hero.cta_primary': 'Bekijk de drop',
    'hero.cta_secondary': 'Bekijk alle 60 smaken 15K',
    'hero.f_puffs': '15.000–20.000 trekjes',
    'hero.f_mesh': 'Mesh coil tech',
    'hero.f_usb': 'USB-C oplaadbaar',
    'hero.f_authentic': 'Authentiek & verzegeld',
    'banner.eyebrow': 'Crypto Exclusief',
    'banner.title_a': 'Betaal met crypto en krijg',
    'banner.title_b': '15% korting',
    'banner.title_c': 'op je hele bestelling.',
    'banner.subtitle': 'BTC · ETH · LTC · USDT — korting automatisch toegepast bij checkout.',
    'banner.cta': 'Shop nu',
    'shop.title': 'Winkel',
    'shop.search_placeholder': 'Zoek producten…',
    'shop.no_results': 'Geen producten gevonden.',
    'shop.add_to_cart': 'In winkelmand',
    'shop.filter_all': 'Alle categorieën',
    'cart.title': 'Je winkelmand',
    'cart.empty': 'Je winkelmand is leeg',
    'cart.continue': 'Verder winkelen',
    'cart.checkout': 'Afrekenen',
    'cart.qty': 'Aantal',
    'cart.remove': 'Verwijder',
    'cart.subtotal': 'Subtotaal',
    'cart.shipping_calc': 'Verzendkosten berekend bij afrekenen',
    'checkout.title': 'Afrekenen',
    'checkout.contact_shipping': 'Contact & Verzending',
    'checkout.email': 'E-mail',
    'checkout.phone': 'Telefoon',
    'checkout.phone_required': 'Telefoonnummer is verplicht',
    'checkout.phone_help': 'Verplicht — koerier kan bellen voor levering.',
    'checkout.first_name': 'Voornaam',
    'checkout.last_name': 'Achternaam',
    'checkout.address': 'Adres',
    'checkout.city': 'Stad',
    'checkout.postal': 'Postcode',
    'checkout.country': 'Land',
    'checkout.shipping_to': 'Verzenden naar',
    'checkout.free_unlocked': 'Gratis verzending vrijgespeeld!',
    'checkout.payment_method': 'Betaalmethode',
    'checkout.payment_info': 'Betaal direct met crypto voor 15% korting, of kies iDEAL / kaart / Bancontact / PayPal — die sturen je naar een voucher-aanbieder (Bitrefill / Azteco / Bitnovo) waar je een crypto-voucher koopt en de code hier plakt.',
    'checkout.your_order': 'Je bestelling',
    'checkout.no_items': 'Geen items —',
    'checkout.add_some': 'voeg producten toe',
    'checkout.promo_code': 'Kortingscode',
    'checkout.apply': 'Toepassen',
    'checkout.remove_coupon': 'Verwijder',
    'checkout.subtotal': 'Subtotaal',
    'checkout.discount': 'Korting',
    'checkout.shipping': 'Verzending',
    'checkout.free': 'Gratis',
    'checkout.total': 'Totaal',
    'checkout.place_order': 'Bestelling plaatsen',
    'checkout.processing': 'Verwerken…',
    'checkout.empty_cart': 'Je winkelmand is leeg',
    'voucher.eyebrow': 'Bestelling geplaatst',
    'voucher.thanks': 'Bedankt',
    'voucher.intro': 'Volg onderstaande stappen om te betalen via crypto-voucher.',
    'voucher.status': 'Wacht op voucher',
    'voucher.how_to_pay': 'Hoe te betalen',
    'voucher.step1_a': 'Bezoek een van de voucher-aanbieders hieronder en koop een',
    'voucher.step1_b': 'Bitcoin (of USDT) voucher',
    'voucher.step1_c': 'voor exact het bedrag van',
    'voucher.step2': 'Betaal met je gewenste fiat-methode bij de voucher-aanbieder (iDEAL, kaart, PayPal, Bancontact, cash, etc.).',
    'voucher.step3_a': 'Mail je voucher-code naar',
    'voucher.step3_b': 'samen met je bestelnummer',
    'voucher.step4': 'Zodra we de voucher inwisselen versturen we je bestelling — meestal binnen 24 uur.',
    'voucher.providers_title': 'Aanbevolen voucher-aanbieders',
    'voucher.open': 'Open',
    'voucher.no_providers': 'Geen voucher-aanbieders ingesteld. Neem contact op met support.',
    'voucher.send_code': 'Stuur je voucher-code',
    'voucher.send_code_help': 'Zodra je je voucher-code hebt, klik hieronder om hem naar ons te mailen met je bestelnummer al ingevuld.',
    'voucher.email_btn': 'Mail voucher-code',
    'voucher.summary': 'Bestelling overzicht',
    'voucher.total_to_pay': 'Te betalen totaal',
    'common.shipping': 'Verzending',
    'common.support': 'Support',
    'common.privacy': 'Privacy',
    'common.terms': 'Voorwaarden',
    'common.legal': 'Legal',
    'common.copyright': 'Alle rechten voorbehouden.',
    'lang.switch': 'Taal',
    'agegate.eyebrow': 'Alleen volwassenen',
    'agegate.title': 'Je moet {age}+ zijn om binnen te komen',
    'agegate.body': 'Deze winkel verkoopt nicotineproducten. Bevestig dat je minimaal {age} jaar oud bent om verder te gaan.',
    'agegate.yes': "Ik ben {age} of ouder — binnenkomen",
    'agegate.no': 'Ik ben nog geen {age} — verlaat de site',
    'agegate.footer': 'Door binnen te komen bevestig je dat je de wettelijke leeftijd in jouw land haalt.',
    'product.add_to_cart': 'In winkelmand',
    'product.buy_now': 'Nu kopen',
    'product.description': 'Beschrijving',
    'product.reviews': 'Beoordelingen',
    'product.related': 'Misschien vind je dit ook leuk',
    'product.in_stock': 'Op voorraad',
    'product.out_of_stock': 'Uitverkocht',
    'product.fast_shipping': 'Snelle discrete verzending',
    'product.authentic': 'Authentiek & verzegeld',
    'product.pay_options': 'iDEAL / Kaart / Crypto',
    'account.login_title': 'Inloggen',
    'account.login_subtitle': 'Log in om je bestelling af te ronden.',
    'account.register_title': 'Account aanmaken',
    'account.register_subtitle': 'Je moet 18+ zijn en een telefoonnummer opgeven zodat wij je bestelling kunnen regelen.',
    'account.password': 'Wachtwoord',
    'account.min_8': 'min. 8 tekens',
    'account.sign_in': 'Inloggen',
    'account.no_account': 'Nog geen account?',
    'account.have_account': 'Al een account?',
    'account.create_account': 'Account aanmaken',
    'account.full_name': 'Volledige naam',
    'account.birthdate': 'Geboortedatum',
    'account.age_blocked': 'Je moet minimaal 18 jaar zijn.',
    'account.birthdate_required': 'Geboortedatum is verplicht.',
    'account.password_short': 'Wachtwoord moet minimaal 8 tekens zijn.',
    'account.welcome': 'Welkom!',
    'account.logout': 'Uitloggen',
    'account.my_account': 'Mijn account',
    'account.required_notice': 'Je hebt een account nodig om te bestellen — registreren duurt 30 seconden.',
    'thanks.eyebrow': 'Bedankt voor je bestelling',
    'thanks.status': 'Wacht op contact',
    'thanks.intro_a': 'Hoi ',
    'thanks.intro_b': ', we hebben je bestelling ontvangen! Een medewerker neemt binnenkort contact met je op om betaling en verzending te regelen.',
    'thanks.next_steps': 'Wat gebeurt er nu',
    'thanks.step_call': 'We bellen of appen je binnen 24 uur op het opgegeven telefoonnummer.',
    'thanks.step_confirm': 'We bevestigen de details en spreken de makkelijkste betaalmethode voor jou af.',
    'thanks.step_ship': 'We versturen je bestelling dezelfde of eerstvolgende werkdag na bevestiging.',
    'thanks.contact_us': 'Wil je ons zelf bereiken?',
    'thanks.reference': 'Vermeld bestelnummer',
    'thanks.not_found': 'Bestelling niet gevonden',
    'thanks.not_found_hint': 'Controleer het bestelnummer of neem contact op met support.',
  },
  de: {
    'nav.home': 'Start',
    'nav.shop': 'Shop',
    'nav.about': 'Über uns',
    'nav.contact': 'Kontakt',
    'nav.admin': 'Admin',
    'nav.search_placeholder': 'Geschmäcker, Vapes suchen…',
    'hero.eyebrow': 'Premium Einweg-Vapes',
    'hero.tagline1': 'We Supply',
    'hero.tagline2': 'Smoke.',
    'hero.subtitle': 'Original RandM Fumot Tornado 15K & 20K Einweg-Vapes — frische Lagerware, unschlagbare Geschmäcker, blitzschneller Versand.',
    'hero.cta_primary': 'Zum Shop',
    'hero.cta_secondary': 'Alle 60 15K-Sorten ansehen',
    'hero.f_puffs': '15.000–20.000 Züge',
    'hero.f_mesh': 'Mesh-Coil-Technik',
    'hero.f_usb': 'USB-C aufladbar',
    'hero.f_authentic': 'Original & versiegelt',
    'banner.eyebrow': 'Krypto Exklusiv',
    'banner.title_a': 'Zahle mit Krypto und erhalte',
    'banner.title_b': '15% Rabatt',
    'banner.title_c': 'auf deine gesamte Bestellung.',
    'banner.subtitle': 'BTC · ETH · LTC · USDT — Rabatt automatisch beim Checkout.',
    'banner.cta': 'Jetzt shoppen',
    'shop.title': 'Shop',
    'shop.search_placeholder': 'Produkte suchen…',
    'shop.no_results': 'Keine Produkte gefunden.',
    'shop.add_to_cart': 'In den Warenkorb',
    'shop.filter_all': 'Alle Kategorien',
    'cart.title': 'Dein Warenkorb',
    'cart.empty': 'Dein Warenkorb ist leer',
    'cart.continue': 'Weiter einkaufen',
    'cart.checkout': 'Zur Kasse',
    'cart.qty': 'Menge',
    'cart.remove': 'Entfernen',
    'cart.subtotal': 'Zwischensumme',
    'cart.shipping_calc': 'Versand wird beim Checkout berechnet',
    'checkout.title': 'Kasse',
    'checkout.contact_shipping': 'Kontakt & Versand',
    'checkout.email': 'E-Mail',
    'checkout.phone': 'Telefon',
    'checkout.phone_required': 'Telefonnummer ist erforderlich',
    'checkout.phone_help': 'Erforderlich — Kurier kann für Lieferung anrufen.',
    'checkout.first_name': 'Vorname',
    'checkout.last_name': 'Nachname',
    'checkout.address': 'Adresse',
    'checkout.city': 'Stadt',
    'checkout.postal': 'PLZ',
    'checkout.country': 'Land',
    'checkout.shipping_to': 'Versand nach',
    'checkout.free_unlocked': 'Kostenloser Versand freigeschaltet!',
    'checkout.payment_method': 'Zahlungsmethode',
    'checkout.payment_info': 'Wir empfangen nur Krypto. Wenn du iDEAL, Karte, Bancontact oder PayPal wählst, wirst du zu Anweisungen für den Kauf eines Krypto-Vouchers (Bitrefill, Azteco, Bitnovo) mit deiner Fiat-Methode weitergeleitet. Krypto-Zahler überspringen diesen Schritt.',
    'checkout.your_order': 'Deine Bestellung',
    'checkout.no_items': 'Keine Artikel —',
    'checkout.add_some': 'füge welche hinzu',
    'checkout.promo_code': 'Gutscheincode',
    'checkout.apply': 'Anwenden',
    'checkout.remove_coupon': 'Entfernen',
    'checkout.subtotal': 'Zwischensumme',
    'checkout.discount': 'Rabatt',
    'checkout.shipping': 'Versand',
    'checkout.free': 'Kostenlos',
    'checkout.total': 'Gesamt',
    'checkout.place_order': 'Bestellung abschicken',
    'checkout.processing': 'Verarbeite…',
    'checkout.empty_cart': 'Dein Warenkorb ist leer',
    'voucher.eyebrow': 'Bestellung aufgegeben',
    'voucher.thanks': 'Danke',
    'voucher.intro': 'Folge den Schritten unten, um per Krypto-Voucher zu bezahlen.',
    'voucher.status': 'Warte auf Voucher',
    'voucher.how_to_pay': 'So bezahlst du',
    'voucher.step1_a': 'Besuche einen der Voucher-Anbieter unten und kaufe einen',
    'voucher.step1_b': 'Bitcoin (oder USDT) Voucher',
    'voucher.step1_c': 'für genau den Betrag von',
    'voucher.step2': 'Bezahle mit deiner gewünschten Fiat-Methode beim Voucher-Anbieter (iDEAL, Karte, PayPal, Bancontact, Bargeld, etc.).',
    'voucher.step3_a': 'Maile deinen Voucher-Code an',
    'voucher.step3_b': 'zusammen mit deiner Bestellnummer',
    'voucher.step4': 'Sobald wir den Voucher einlösen, versenden wir deine Bestellung — meist binnen 24 Stunden.',
    'voucher.providers_title': 'Empfohlene Voucher-Anbieter',
    'voucher.open': 'Öffnen',
    'voucher.no_providers': 'Keine Voucher-Anbieter konfiguriert. Bitte kontaktiere den Support.',
    'voucher.send_code': 'Sende deinen Voucher-Code',
    'voucher.send_code_help': 'Sobald du deinen Voucher-Code hast, klicke unten, um ihn mit vorgefüllter Bestellnummer an uns zu mailen.',
    'voucher.email_btn': 'Voucher-Code mailen',
    'voucher.summary': 'Bestellübersicht',
    'voucher.total_to_pay': 'Zu zahlender Betrag',
    'common.shipping': 'Versand',
    'common.support': 'Support',
    'common.privacy': 'Datenschutz',
    'common.terms': 'AGB',
    'common.legal': 'Impressum',
    'common.copyright': 'Alle Rechte vorbehalten.',
    'lang.switch': 'Sprache',
    'agegate.eyebrow': 'Nur Erwachsene',
    'agegate.title': 'Du musst {age}+ sein, um einzutreten',
    'agegate.body': 'Dieser Shop verkauft Nikotinprodukte. Bitte bestätige, dass du mindestens {age} Jahre alt bist.',
    'agegate.yes': "Ich bin {age} oder älter — eintreten",
    'agegate.no': 'Ich bin unter {age} — verlassen',
    'agegate.footer': 'Mit dem Eintritt bestätigst du das gesetzliche Alter in deinem Land.',
    'product.add_to_cart': 'In den Warenkorb',
    'product.buy_now': 'Jetzt kaufen',
    'product.description': 'Beschreibung',
    'product.reviews': 'Bewertungen',
    'product.related': 'Das könnte dir auch gefallen',
    'product.in_stock': 'Auf Lager',
    'product.out_of_stock': 'Ausverkauft',
    'product.fast_shipping': 'Schneller diskreter Versand',
    'product.authentic': 'Original & versiegelt',
    'product.pay_options': 'iDEAL / Karte / Krypto',
    'account.login_title': 'Anmelden',
    'account.login_subtitle': 'Melde dich an, um deine Bestellung abzuschließen.',
    'account.register_title': 'Konto erstellen',
    'account.register_subtitle': 'Du musst 18+ sein und eine Telefonnummer angeben.',
    'account.password': 'Passwort',
    'account.min_8': 'min. 8 Zeichen',
    'account.sign_in': 'Anmelden',
    'account.no_account': 'Noch kein Konto?',
    'account.have_account': 'Schon ein Konto?',
    'account.create_account': 'Konto erstellen',
    'account.full_name': 'Vollständiger Name',
    'account.birthdate': 'Geburtsdatum',
    'account.age_blocked': 'Du musst mindestens 18 Jahre alt sein.',
    'account.birthdate_required': 'Geburtsdatum ist erforderlich.',
    'account.password_short': 'Passwort muss mindestens 8 Zeichen haben.',
    'account.welcome': 'Willkommen!',
    'account.logout': 'Abmelden',
    'account.my_account': 'Mein Konto',
    'account.required_notice': 'Du brauchst ein Konto zum Bestellen — 30 Sekunden Registrierung.',
    'thanks.eyebrow': 'Danke für deine Bestellung',
    'thanks.status': 'Warte auf Kontakt',
    'thanks.intro_a': 'Hi ',
    'thanks.intro_b': ', wir haben deine Bestellung erhalten! Ein Mitarbeiter meldet sich in Kürze bei dir.',
    'thanks.next_steps': 'Was passiert als Nächstes',
    'thanks.step_call': 'Wir rufen dich binnen 24 Stunden auf deiner Nummer an.',
    'thanks.step_confirm': 'Wir bestätigen Details und vereinbaren die einfachste Zahlungsmethode.',
    'thanks.step_ship': 'Nach Bestätigung versenden wir am selben oder nächsten Werktag.',
    'thanks.contact_us': 'Uns zuerst kontaktieren?',
    'thanks.reference': 'Bitte Bestellnummer angeben',
    'thanks.not_found': 'Bestellung nicht gefunden',
    'thanks.not_found_hint': 'Bitte Bestellnummer prüfen oder Support kontaktieren.',
  },
  fr: {
    'nav.home': 'Accueil',
    'nav.shop': 'Boutique',
    'nav.about': 'À propos',
    'nav.contact': 'Contact',
    'nav.admin': 'Admin',
    'nav.search_placeholder': 'Rechercher saveurs, vapes…',
    'hero.eyebrow': 'Vapes Jetables Premium',
    'hero.tagline1': 'We Supply',
    'hero.tagline2': 'Smoke.',
    'hero.subtitle': 'Vapes jetables RandM Fumot Tornado 15K & 20K authentiques — stock frais, saveurs imbattables, livraison ultra-rapide.',
    'hero.cta_primary': 'Voir le drop',
    'hero.cta_secondary': 'Voir toutes les 60 saveurs 15K',
    'hero.f_puffs': '15 000–20 000 bouffées',
    'hero.f_mesh': 'Coil mesh',
    'hero.f_usb': 'Rechargeable USB-C',
    'hero.f_authentic': 'Authentique & scellé',
    'banner.eyebrow': 'Crypto Exclusif',
    'banner.title_a': 'Payez en crypto et obtenez',
    'banner.title_b': '15% de réduction',
    'banner.title_c': 'sur toute votre commande.',
    'banner.subtitle': 'BTC · ETH · LTC · USDT — réduction auto au checkout.',
    'banner.cta': 'Acheter',
    'shop.title': 'Boutique',
    'shop.search_placeholder': 'Rechercher des produits…',
    'shop.no_results': 'Aucun produit trouvé.',
    'shop.add_to_cart': 'Ajouter au panier',
    'shop.filter_all': 'Toutes catégories',
    'cart.title': 'Votre panier',
    'cart.empty': 'Votre panier est vide',
    'cart.continue': 'Continuer mes achats',
    'cart.checkout': 'Passer commande',
    'cart.qty': 'Qté',
    'cart.remove': 'Retirer',
    'cart.subtotal': 'Sous-total',
    'cart.shipping_calc': 'Frais de port calculés au checkout',
    'checkout.title': 'Commande',
    'checkout.contact_shipping': 'Contact & Livraison',
    'checkout.email': 'E-mail',
    'checkout.phone': 'Téléphone',
    'checkout.phone_required': 'Le numéro de téléphone est requis',
    'checkout.phone_help': 'Requis — le coursier peut vous appeler pour la livraison.',
    'checkout.first_name': 'Prénom',
    'checkout.last_name': 'Nom',
    'checkout.address': 'Adresse',
    'checkout.city': 'Ville',
    'checkout.postal': 'Code postal',
    'checkout.country': 'Pays',
    'checkout.shipping_to': 'Livraison vers',
    'checkout.free_unlocked': 'Livraison gratuite débloquée !',
    'checkout.payment_method': 'Méthode de paiement',
    'checkout.payment_info': 'Nous encaissons uniquement en crypto. Si vous choisissez iDEAL, carte, Bancontact ou PayPal, vous serez redirigé vers les instructions pour acheter un voucher crypto (Bitrefill, Azteco, Bitnovo) avec votre méthode fiat. Les payeurs crypto sautent cette étape.',
    'checkout.your_order': 'Votre commande',
    'checkout.no_items': 'Aucun article —',
    'checkout.add_some': 'ajoutez-en',
    'checkout.promo_code': 'Code promo',
    'checkout.apply': 'Appliquer',
    'checkout.remove_coupon': 'Retirer',
    'checkout.subtotal': 'Sous-total',
    'checkout.discount': 'Réduction',
    'checkout.shipping': 'Livraison',
    'checkout.free': 'Gratuit',
    'checkout.total': 'Total',
    'checkout.place_order': 'Passer commande',
    'checkout.processing': 'Traitement…',
    'checkout.empty_cart': 'Votre panier est vide',
    'voucher.eyebrow': 'Commande passée',
    'voucher.thanks': 'Merci',
    'voucher.intro': 'Suivez les étapes ci-dessous pour payer via voucher crypto.',
    'voucher.status': 'En attente de voucher',
    'voucher.how_to_pay': 'Comment payer',
    'voucher.step1_a': 'Visitez l\'un des fournisseurs de voucher ci-dessous et achetez un',
    'voucher.step1_b': 'voucher Bitcoin (ou USDT)',
    'voucher.step1_c': 'pour le montant exact de',
    'voucher.step2': 'Payez avec votre méthode fiat préférée chez le fournisseur de voucher (iDEAL, carte, PayPal, Bancontact, cash, etc.).',
    'voucher.step3_a': 'Envoyez votre code voucher par e-mail à',
    'voucher.step3_b': 'avec votre numéro de commande',
    'voucher.step4': 'Dès que nous échangeons le voucher, nous expédions votre commande — habituellement sous 24h.',
    'voucher.providers_title': 'Fournisseurs de voucher recommandés',
    'voucher.open': 'Ouvrir',
    'voucher.no_providers': 'Aucun fournisseur configuré. Contactez le support.',
    'voucher.send_code': 'Envoyez votre code voucher',
    'voucher.send_code_help': 'Une fois votre code voucher obtenu, cliquez ci-dessous pour nous l\'envoyer par e-mail avec votre numéro de commande pré-rempli.',
    'voucher.email_btn': 'E-mailer le code voucher',
    'voucher.summary': 'Récapitulatif',
    'voucher.total_to_pay': 'Total à payer',
    'common.shipping': 'Livraison',
    'common.support': 'Support',
    'common.privacy': 'Confidentialité',
    'common.terms': 'CGV',
    'common.legal': 'Mentions légales',
    'common.copyright': 'Tous droits réservés.',
    'lang.switch': 'Langue',
    'agegate.eyebrow': 'Adultes uniquement',
    'agegate.title': 'Vous devez avoir {age}+ pour entrer',
    'agegate.body': 'Cette boutique vend des produits contenant de la nicotine. Veuillez confirmer que vous avez au moins {age} ans.',
    'agegate.yes': "J'ai {age} ans ou plus — entrer",
    'agegate.no': "Je n'ai pas {age} ans — quitter",
    'agegate.footer': "En entrant, vous confirmez avoir l'âge légal dans votre pays.",
    'product.add_to_cart': 'Ajouter au panier',
    'product.buy_now': 'Acheter maintenant',
    'product.description': 'Description',
    'product.reviews': 'Avis',
    'product.related': 'Vous aimerez peut-être aussi',
    'product.in_stock': 'En stock',
    'product.out_of_stock': 'Rupture de stock',
    'product.fast_shipping': 'Livraison rapide discrète',
    'product.authentic': 'Authentique & scellé',
    'product.pay_options': 'iDEAL / Carte / Crypto',
    'account.login_title': 'Connexion',
    'account.login_subtitle': 'Connectez-vous pour finaliser votre commande.',
    'account.register_title': 'Créer un compte',
    'account.register_subtitle': 'Vous devez avoir 18+ et fournir un téléphone.',
    'account.password': 'Mot de passe',
    'account.min_8': 'min. 8 caractères',
    'account.sign_in': 'Se connecter',
    'account.no_account': 'Pas encore de compte ?',
    'account.have_account': 'Déjà un compte ?',
    'account.create_account': 'Créer un compte',
    'account.full_name': 'Nom complet',
    'account.birthdate': 'Date de naissance',
    'account.age_blocked': 'Vous devez avoir au moins 18 ans.',
    'account.birthdate_required': 'La date de naissance est requise.',
    'account.password_short': 'Le mot de passe doit avoir au moins 8 caractères.',
    'account.welcome': 'Bienvenue !',
    'account.logout': 'Se déconnecter',
    'account.my_account': 'Mon compte',
    'account.required_notice': 'Un compte est requis — inscription en 30 secondes.',
    'thanks.eyebrow': 'Merci pour votre commande',
    'thanks.status': 'En attente de contact',
    'thanks.intro_a': 'Bonjour ',
    'thanks.intro_b': ', nous avons reçu votre commande ! Un représentant vous contactera sous peu.',
    'thanks.next_steps': 'Prochaines étapes',
    'thanks.step_call': 'Nous vous appelons/écrivons sous 24h au numéro fourni.',
    'thanks.step_confirm': 'Nous confirmons les détails et convenons du mode de paiement.',
    'thanks.step_ship': "Envoi le jour même ou le lendemain après confirmation.",
    'thanks.contact_us': 'Besoin de nous joindre ?',
    'thanks.reference': 'Merci de citer la commande',
    'thanks.not_found': 'Commande introuvable',
    'thanks.not_found_hint': 'Vérifiez le numéro ou contactez le support.',
  },
};

export default translations;
